/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { Navigate, Route, Routes } from "react-router";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import { ContentRoute } from "../../../../_metronic/layout";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Registration from "./Registration";
import CheckoutPage from "../../../pages/CheckoutPage";

export function AuthPage() {
  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Routes>
                {ContentRoute({ path: "login", component: Login })}
                {ContentRoute({ path: "registration", component: Registration })}
                {ContentRoute({ path: "forgot-password", component: ForgotPassword })}
                <Route path="" element={<Navigate to="login" replace />} />
                <Route path="*" element={<Navigate to="login" replace />} />
              </Routes>
            </div>
            {/*end::Content body*/}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
